import { useMutation as e } from "@tanstack/react-query";
//#region src/hooks/useMutation.ts
function t(t) {
	return e(t);
}
//#endregion
export { t as useMutation };
